import { AiOutlineCloudUpload, AiOutlinePartition } from 'react-icons/ai';
import { AiOutlineFundView } from 'react-icons/ai';
import { BsFillPeopleFill } from 'react-icons/bs';
import { VscServerProcess } from 'react-icons/vsc';
import { FcInspection, FcWorkflow } from 'react-icons/fc';
import { MdApproval } from 'react-icons/md';
import { TbReport } from 'react-icons/tb';
import { ImStatsDots } from 'react-icons/im';
import { GiProcessor } from 'react-icons/gi';
import { SiPostman } from 'react-icons/si';

const tiles = [
  // {
  //   sNo: 1,
  //   link: '/common/clauseUploadList?documentType=masterProcedureClause4&heading=MASTER PROCEDURE',
  //   isLink: true,
  //   clauseNo: 4,
  //   icon: <AiOutlineCloudUpload size="5rem" color="#135089" />,
  //   p: 'MASTER',
  //   span: 'PROCEDURE',
  //   isIcon: true,
  // },
  // {
  //   sNo: 1,
  //   link: '/common/clauseUploadList?documentType=coherencePlanClause4&heading=LIST OF COHERENCE PLAN',
  //   isLink: true,
  //   clauseNo: 4,
  //   icon: <AiOutlineCloudUpload size="5rem" color="#135089" />,
  //   p: 'LIST OF COHERENCE',
  //   span: 'PLAN',
  //   isIcon: true,
  // },
  // {
  //   sNo: 1,
  //   link: '/common/clauseUploadList?documentType=coherenceCheckingClause4&heading=LIST OF COHERENCE CHECKING',
  //   isLink: true,
  //   clauseNo: 4,
  //   icon: <AiOutlineCloudUpload size="5rem" color="#135089" />,
  //   p: 'LIST OF COHERENCE',
  //   span: 'CHECKING',
  //   isIcon: true,
  // },
  {
    sNo: 1,
    link: '/admin/part_list?filter=part_number',
    isLink: true,
    clauseNo: 4,
    icon: <AiOutlinePartition size="5rem" color="#a12222" />,
    p: 'ADD',
    span: 'PART',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/admin/ppap_documents?filter=part_number',
    isLink: true,
    clauseNo: 4,
    p: 'VIEW',
    span: 'PPAP DOCUMENTS',
    icon: <AiOutlineFundView size="5rem" color="#343a40" />,
    isIcon: true,
  },
  {
    sNo: 3,
    link: '/admin/customer_list?filter=createdAt',
    isLink: true,
    clauseNo: 4,
    p: 'MASTER LIST OF',
    span: 'CUSTOMER',
    icon: <BsFillPeopleFill size="5rem" color="#135089" />,
    isIcon: true,
  },
  {
    sNo: 4,
    link: '/common/processList?filter=createdAt',
    isLink: true,
    clauseNo: 4,
    p: 'MASTER LIST OF',
    span: 'PROCESS',
    icon: <GiProcessor size="5rem" color="#135089" />,
    isIcon: true,
  },
  {
    sNo: 5,
    link: '/common/manProcessMatrixCreate', // ?filter=createdAt
    isLink: true,
    clauseNo: 4,
    icon: <SiPostman size="5rem" color="#135089" />,
    p: 'Man Process',
    span: 'Matrix',
    isIcon: true,
  },
  {
    sNo: 5,
    link: '/common/manPartMatrixCreate', // ?filter=createdAt
    isLink: true,
    clauseNo: 4,
    icon: <FcWorkflow size="5rem" color="#135089" />,
    p: 'Man Part',
    span: 'Matrix',
    isIcon: true,
  },
  // {
  //   sNo: 4,
  //   link: '/common/pirtiles',
  //   isLink: true,
  //   clauseNo: 4,
  //   p: 'Process Inspection ',
  //   span: 'Reports',
  //   icon: <VscServerProcess size="5rem" color="#a12222" />,
  //   isIcon: true,
  // },
  // {
  //   sNo: 1,
  //   link: '/admin/pirList',
  //   isLink: true,
  //   icon: <VscServerProcess size="5rem" color="#adb5bd" />,
  //   p: 'LINE',
  //   span: 'INSPECTION OLD',
  //   isIcon: true,
  // },
  // {
  //   sNo: 1,
  //   link: '/admin/lineInspectionList',
  //   isLink: true,
  //   icon: <VscServerProcess size="5rem" color="#a12222" />,
  //   p: 'LINE',
  //   span: 'INSPECTION',
  //   isIcon: true,
  // },
  {
    sNo: 1,
    link: '/admin/pdirList',
    isLink: true,
    icon: <TbReport size="5rem" color="#a12222" />,
    p: 'PDIR',
    span: '',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/common/pirPqccList',
    isLink: true,
    icon: <TbReport size="5rem" color="#a12222" />,
    p: 'PIR',
    span: 'PQCC',
    isIcon: true,
  },
  // {
  //   sNo: 2,
  //   link: '/common/spcPlanTiles',
  //   isLink: true,
  //   icon: <ImStatsDots size="5rem" color="#212529" />,
  //   p: 'SPC',
  //   span: 'PLAN',
  //   isIcon: true,
  // },
  {
    sNo: 1,
    link: '/admin/setupList',
    isLink: true,
    icon: <MdApproval size="5rem" color="#a12222" />,
    p: 'FPA/',
    span: 'LPA',
    isIcon: true,
  },
  // {
  //   sNo: 1,
  //   link: '/admin/incomingReportList',
  //   isLink: true,
  //   icon: <FcInspection size="5rem" color="#a12222" />,
  //   p: 'INCOMING INSPECTION',
  //   span: 'STANDARD',
  //   isIcon: true,
  // },
  // {
  //   sNo: 1,
  //   link: '/admin/materialIncomingList',
  //   isLink: true,
  //   icon: <FcInspection size="5rem" color="#a12222" />,
  //   p: 'INCOMING MATERIAL',
  //   span: 'INSPECTION',
  //   isIcon: true,
  // },
  {
    sNo: 8,
    link: '/common/customerList',
    isLink: true,
    icon: <BsFillPeopleFill size="5rem" color="#135089" />,
    p: 'CUSTOMER STANDARDS',
    span: 'MODULE',
    isIcon: true,
  },
];

export default tiles;
